import { supabase } from "@/integrations/supabase/client";
import type { AuditActionType } from "@/admin/types/admin";

interface LogAdminActionParams {
  adminUserId: string;
  actionType: AuditActionType;
  targetType: string;
  targetId: string;
  reasonCode?: string;
  notes?: string;
  beforeState?: Record<string, unknown>;
  afterState?: Record<string, unknown>;
}

/**
 * Enregistre une entrée dans audit_logs après chaque action admin.
 * Appelé dans les onSuccess des mutations hooks admin.
 */
export async function logAdminAction(params: LogAdminActionParams): Promise<void> {
  const { error } = await supabase.from("audit_logs").insert({
    admin_user_id: params.adminUserId,
    action_type: params.actionType,
    target_type: params.targetType,
    target_id: params.targetId,
    reason_code: params.reasonCode ?? null,
    notes: params.notes ?? null,
    before_state: params.beforeState ?? null,
    after_state: params.afterState ?? null,
  });

  if (error) {
    console.error("[adminService] logAdminAction error:", error.message);
  }
}
